import QuestionAlert from 'src/assets/images/common/question-alert.svg';
const isFlipkart = window.location.href.indexOf('/flipkart') > -1;
const isAmazon = window.location.href.indexOf('/amazon') > -1;
const isMyntra = window.location.href.indexOf('/myntra') > -1;
const isBlinkit = window.location.href.indexOf('/blinkit') > -1;
const isInstamart = window.location.href.indexOf('/instamart') > -1;
const isZepto = window.location.href.indexOf('/zepto') > -1;
const isBigbasket = window.location.href.indexOf('/bigbasket') > -1;


export const TextualRes = [
    ...(isFlipkart || isAmazon) ? ([]) : ([
        {
            title: isFlipkart || isAmazon ? 'Types Of Keywords' : 'Brand/Competitor/Generic',
            is_add_new: 0,
            is_radio: 1,
            is_drag: 0,
            column_level: 'brand',
            column_key: 'type_id',
            column_name: 'type_name',
            commonPayload: {
                level: 'brand'
            },
            apiInfo: {
                crudDictionary: {
                    add: '',
                    edit: '',
                    delete: '',
                    update: '',
                },
                triggerDictionary: {
                    list_trigger: '/list-brand-triggers',
                    add_trigger: '/add-brand-triggers',
                    update_trigger: '/update-brand-triggers',
                    update_trigger: '/update-brand-triggers',
                    delete_trigger: '/delete-brand-triggers',
                    fetch_trigger_results_count: '/kw-brand-count',
                    fetch_trigger_results_queries: '/kw-brand-query',
                }
            }
        },
        {
            title: 'Category',
            is_add_new: 1,
            is_radio: 1,
            is_drag: 1,
            column_level: 'category',
            column_key: 'category_id',
            column_name: 'category_name',
            commonPayload: {
                level: 'category'
            },
            apiInfo: {
                crudDictionary: {
                    add: '/add-category-kw',
                    edit: '',
                    delete: '/delete-kw-levels',
                    update: '/update-level-name-kw',
                },
                triggerDictionary: {
                    list_trigger: '/list-category-triggers',
                    add_trigger: '/add-triggers-conditions',
                    update_trigger: '/update-category-triggers',
                    delete_trigger: '/delete-category-triggers',
                    fetch_trigger_results_count: '/kw-category-count',
                    fetch_trigger_results_queries: '/kw-category-query',
                }
            }
        },
        {
            title: 'Sub Category',
            is_add_new: 1,
            is_radio: 1,
            is_drag: 1,
            column_level: 'subcategory',
            column_key: 'subcategory_id',
            column_name: 'subcategory_name',
            commonPayload: {
                level: 'subcategory'
            },
            apiInfo: {
                crudDictionary: {
                    add: '/add-subcategory-kw',
                    edit: '/update-level-name-kw',
                    delete: '/delete-kw-levels',
                    update: '/update-level-name-kw',
                },
                triggerDictionary: {
                    list_trigger: '/list-subcategory-triggers',
                    add_trigger: '/add-subcategory-triggers',
                    update_trigger: '/update-subcategory-triggers',
                    delete_trigger: '/delete-subcategory-triggers',
                    fetch_trigger_results_count: '/kw-subcategory-count',
                    fetch_trigger_results_queries: '/kw-subcategory-query',
                }
            }
        }
    ])
     
]

export const TriggerItemDefault = [
    {
        conditionName: "Condition",
        orderNumber: 1,
        triggers: [
            [
                {
                    trigger_condition: "contains",
                    trigger_word: ""
                }   
            ]
        ]
    }
]

export const TextualOptions = [
    { id: 1, label: 'contains', name: 'contains', value: 'contains' },
    { id: 2, label: 'not contains', name: 'not contains', value: 'not contains' },
    { id: 3, label: 'begins with', name: 'begins with', value: 'begins with' },
    { id: 4, label: 'not begins with', name: 'not begins with', value: 'not begins with' },
    { id: 5, label: 'ends with', name: 'ends with', value: 'ends with' },
    { id: 6, label: 'not ends with', name: 'not ends with', value: 'not ends with' },
    { id: 7, label: 'equals to', name: 'equals to', value: 'equals to' },
    // ...(window.location.href.indexOf('/flipkart') > -1 ? [
    //     { id: 8, label: 'in', name: 'in', value: 'in' },
    // { id: 9, label: 'not in', name: 'not in', value: 'not in' }
    // ]: [])

]

export const DEFAULT_CONFIRMATION_MODAL = {
    show: false,
    icon: QuestionAlert,
    title: "",
    message: "",
    action: () => {}
}

export const REPORTS = [
    ...(isFlipkart || isAmazon) ? ([
          {
            label: 'Search Term',
            aggregate: 'SearchTerm',
            title: 'search_term',
            value: 2
          },
          ...(isAmazon ? [
            {
                label: 'Advertised ASIN`s',
                aggregate: 'AdvertisedASINs',
                title: 'asin',
                value: 3
              },
              {
                label: 'Targeting',
                title: 'targeting',
                aggregate: 'Targeting',
                value: 7
              }
          ] : [{
            label: 'FSN',
            aggregate: 'FsnId',
            title: 'fsn',
            value: 3
          },
          {
            label: 'Keyword',
            title: 'keyword',
            aggregate: 'Targeting',
            value: 1
          },
          {
            label: 'Product Titles',
            aggregate: 'ProductName',
            title: 'product_titles',
            value: 4
          }]),
          {
            label: 'Ad Groups',
            aggregate: isAmazon ? 'AdGroupName'  : 'AdGroup',
            title: 'ad_groups',
            value: 5
          },
          {
            label: 'Campaigns',
            aggregate: isAmazon ? 'CampaignName' : 'Campaign',
            title: 'campaigns',
            value: 6
          }
    ]) : isMyntra ? ([
        {
            label: 'Ad Groups',
            aggregate: isAmazon ? 'AdGroupName'  : 'AdGroup',
            title: 'ad_groups',
            value: 1
          },
          {
            label: 'Campaigns',
            aggregate: isAmazon ? 'CampaignName' : 'Campaign',
            title: 'campaigns',
            value: 2
          },
          {
            label: 'Product Id',
            title: 'product_id',
            value: 3
          },
          {
            label: 'Product Name',
            title: 'product_name',
            value: 4
          },
          {
            label: 'Search Term',
            title: 'search_term',
            aggregate: 'SearchTerm',
            value: 5
          },
          {
            label: 'Targeting',
            title: 'targeting',
            aggregate: 'Targeting',
            value: 6
          },
    ]) : isBlinkit ? ([
        {
          label: 'Campaigns',
          aggregate: isAmazon ? 'CampaignName' : 'Campaign',
          title: 'campaigns',
          value: 1
        },
        {
          label: 'Targeting',
          title: 'targeting',
          value: 2
        }
  ]) : isInstamart ? ([
      {
        label: 'Product Name',
        aggregate: 'product_name',
        title: 'product_name',
        value: 1
      },
      {
        label: 'Keyword',
        title: 'keyword',
        aggregate: 'keyword',
        value: 2
      },
      {
        label: 'Campaigns',
        title: 'campaigns',
        aggregate: 'campaigns',
        value: 3
      }
  ]) :  isZepto ? ([
      {
        label: 'Campaigns',
        aggregate: 'Campaigns',
        title: 'campaigns',
        value: 1
      },
      {
        label: 'Keyword',
        title: 'keyword',
        aggregate: 'Keyword',
        value: 2
      },
      {
        label: 'Product Name',
        title: 'product_name',
        aggregate: 'ProductName',
        value: 3
      },
      {
        label: 'Product Id',
        title: 'product_id',
        aggregate: 'ProductId',
        value: 4
      },
])   :  isZepto ? ([
      {
        label: 'Campaigns',
        aggregate: 'Campaigns',
        title: 'campaigns',
        value: 1
      },
      {
        label: 'Keyword',
        title: 'keyword',
        aggregate: 'Keyword',
        value: 2
      },
      {
        label: 'Product Name',
        title: 'product_name',
        aggregate: 'ProductName',
        value: 3
      },
      {
        label: 'Product Id',
        title: 'product_id',
        aggregate: 'ProductId',
        value: 4
      },
])     :  isBigbasket ? ([
      {
        label: 'Keyword',
        title: 'keyword',
        aggregate: 'Keyword',
        value: 1
      },
      {
        label: 'Product',
        title: 'product',
        aggregate: 'Product',
        value: 2
      },
      {
        label: 'Location',
        title: 'location',
        aggregate: 'Location',
        value: 3
      },
      {
        label: 'Sku Id',
        title: 'sku_id',
        aggregate: 'sku_id',
        value: 4
      },
])  : ([])
    
  ];

  